import {Dialog} from 'primereact/dialog'
import React, {useContext, useEffect, useState} from 'react'
import {Button} from 'primereact/button'
import {useMountEffect} from 'primereact/hooks'
import {isEmpty} from 'lodash'
import {CommonContext} from '../common/context/commonContext'
import {GoodsAdjustmentReq, InventoryGoodsAdjustmentProps, InventoryGoodsDetail,} from '../../types/inventory'
import {CommonCode} from '../../types/common'
import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown'
import {InputText} from 'primereact/inputtext'
import {useFormik} from 'formik'
import {number, object, string} from 'yup'
import {Calendar, CalendarChangeEvent} from 'primereact/calendar'
import {Checkbox} from 'primereact/checkbox'
import {InputNumber} from 'primereact/inputnumber'
import moment from 'moment'
import CommonProgressSpinner from '../common/CommonProgressSpinner'
import {useTranslation} from 'react-i18next'
import {tokens} from 'locales/tokens'

const InventoryGoodsAdjustmentDialog = (props: InventoryGoodsAdjustmentProps) => {
    const { $toast, $http, $alert, $codes } = useContext(CommonContext)
    const { t } = useTranslation()
    const [disableCalendar, setDisableCalendar] = useState<boolean | undefined>(true)
    const [invnAdjsTypCd, setInvnAdjsTypCd] = useState<CommonCode[]>()
    const [preInvnAdjsTypCd, setPreInvnAdjsTypCd] = useState<CommonCode[]>()
    const [calendarDate, setCalendarDate] = useState<Date>()

    useEffect(() => {}, [$codes, $http])

    const [goods, setGoods] = useState<InventoryGoodsDetail>({
        rowNum: 0,
        lctSeq: '',
        goodsId: '',
        goodsNm: '',
        centerId: '',
        centerNm: '',
        invnSeq: 0,
        goodsQty: 0,
        pckGoodsQty: 0,
        avlbGoodsQty: 0,
        gdslsUnitCd: '',
        specTxt: '',
        shlfYmd: '',
        shlfYmdFm: '',
        shlfRemainDay: 0,
        strgDay: 0,
        prchUnitAmt: 0,
        imageUri: '',
        shlfYn: '',
        lotNo: '',
        sysCd: '',
    })
    const [loading, setLoading] = useState<boolean>(false)

    const findCodes = async (p: InventoryGoodsDetail) => {
        await $codes(['INVN_ADJS_TYP'], true).then((result: CommonCode[][]) => {
            const [INVN_ADJS_TYP] = result
            INVN_ADJS_TYP[0].displayNm = t(tokens.common.select_adjustment_type)
            INVN_ADJS_TYP[0].codeNm = t(tokens.common.select_adjustment_type)
            // AB폐기,LOS손망실,RCV손망실복구,SHL유통기한조정,LOT LOT번호 수정

            if (p.shlfYn !== 'Y') {
                setInvnAdjsTypCd(INVN_ADJS_TYP.filter((d) => d.codeId !== 'ML' && d.codeId !== 'SHL')) //미상차는 기사 검수에서 자동 처리
            } else {
                setInvnAdjsTypCd(INVN_ADJS_TYP.filter((d) => d.codeId !== 'ML')) //미상차는 기사 검수에서 자동 처리
            }
        })
    }

    useMountEffect(() => {
        if (!props.visible) return
        if (!props.data) return
        console.log('InventoryGoodsAdjustmentDialog', props.data)
        findCodes(props.data)

        setGoods(props.data)
        formik.validateField('invnAdjsTypCd')
        formik.validateField('goodsQty')
    })

    const onChangeInvnAdjsTypCd = (e: DropdownChangeEvent) => {
        if (!e.value) return
        formik.setFieldValue('invnAdjsTypCd', e.value)

        if ((e.value === 'SHL' || e.value === 'RCV') && props.data.shlfYn === 'Y') {
            // AB폐기,LOS손망실,RCV손망실복구,SHL유통기한조정,LOT LOT번호 수정
            setDisableCalendar(false)
        } else if (e.value === 'LOT' && props.data.shlfYn === 'Y') {
            setDisableCalendar(true)
            setCalendarDate(moment(props.data.shlfYmd).toDate())
            formik.setFieldValue('shlfYmd', props.data.shlfYmd)
            formik.validateField('shlfYmd')
        } else {
            setDisableCalendar(true)
            setCalendarDate(undefined)
            formik.setFieldValue('shlfYmd', '')
            formik.validateField('shlfYmd')
        }

        //set 유통기한
        if (props.data.shlfYn !== 'Y') {
            // 유통기한 필요없는 상품
            if (e.value === 'RCV') {
                // moment(e.value).format('YYYYMMDD')
                // console.log('moment(\'99991231\').toDate()', moment('99991231').toDate())
                setCalendarDate(moment('99991231').toDate())
                formik.setFieldValue('shlfYmd', '99991231')
                formik.validateField('shlfYmd')
            } else {
                setCalendarDate(undefined)
                formik.setFieldValue('shlfYmd', '')
                formik.validateField('shlfYmd')
            }
        }
    }

    const onClickAllGoodsQty = () => {
        formik.setFieldValue('goodsQty', goods.avlbGoodsQty)
    }

    const initialValues: GoodsAdjustmentReq = {
        invnAdjsTypCd: '',
        goodsQty: undefined,
        shlfYmd: '',
        lotNo: '',
    }
    const formik = useFormik({
        initialValues,
        validationSchema: object({
            invnAdjsTypCd: string().required(t(tokens.common.selecting_adjustment_type_is_required)),
            goodsQty: number()
                .required(t(tokens.common.please_enter_adjustment_quantity))
                .min(1, t(tokens.inventory.enter_minimum_adjustment_qty_of_1_or_more))
                .when('invnAdjsTypCd', {
                    is: (v: string) => v !== 'RCV', // 손망실복구, 수량 제한없이 입력
                    then: (schema) =>
                        schema.max(
                            goods.avlbGoodsQty,
                            `${t(tokens.common.input_adjustment_quantity_is_adjustable_quantity)}:` +
                                goods.avlbGoodsQty +
                                `${t(tokens.common.there_are_more)}`,
                        ),
                }),
            shlfYmd: string().when('invnAdjsTypCd', {
                is: (v: string) => (v === 'SHL' || v === 'RCV') && props.data.shlfYn === 'Y',
                then: (schema) => schema.required(t(tokens.inventory.consumption_deadline_required_for_adjustment)),
            }),
            lotNo: string().when('invnAdjsTypCd', {
                is: (v: string) => (v === 'LOT'),
                then: (schema) => schema.required(t(tokens.inventory.lot_no_required_for_adjustment)),
            }),
        }),
        onSubmit: async (param: GoodsAdjustmentReq) => {
            if (isEmpty(goods) || isEmpty(goods.lctSeq)) {
                $toast({ title: t(tokens.common.accept), text: t(tokens.inventory.no_items_to_adjust), icon: 'warning' })
                return
            }
            let invnAdjsTyp
            if (!isEmpty(invnAdjsTypCd)) {
                invnAdjsTyp = invnAdjsTypCd?.find((v) => v.codeId === param.invnAdjsTypCd)
            } else {
                $toast({ title: t(tokens.common.accept), text: t(tokens.inventory.no_items_to_adjust), icon: 'warning' })
                return
            }

            let confirmMsg
            if (param.invnAdjsTypCd === 'SHL') {
                // AB폐기,LOS손망실,RCV손망실복구,SHL유통기한조정
                confirmMsg =
                    goods.goodsNm +
                    ` ${t(tokens.common.product)}` +
                    param.goodsQty +
                    ` ${t(tokens.common.item_count)}` +
                    invnAdjsTyp?.codeNm +
                    ` ${t(tokens.inventory.adjust_consumption_deadline_due_to_reason)}\n\n ${t(tokens.inventory.confirm_adjustment)}`
            } else if (param.invnAdjsTypCd === 'RCV') {
                confirmMsg =
                    goods.goodsNm +
                    ` ${t(tokens.common.product)}` +
                    param.goodsQty +
                    ` ${t(tokens.common.item_count)}` +
                    invnAdjsTyp?.codeNm +
                    ` ${t(tokens.inventory.adjust_inventory_qty_due_to_reason)}\n\n ${t(tokens.inventory.confirm_adjustment)}`
            } else {
                confirmMsg =
                    goods.goodsNm +
                    ` ${t(tokens.common.product)}` +
                    param.goodsQty +
                    ` ${t(tokens.common.item_count)}` +
                    invnAdjsTyp?.codeNm +
                    ` ${t(tokens.inventory.decrease_inventory_qty_due_to_reason)}\n\n ${t(tokens.inventory.confirm_adjustment)}`
            }

            const isConfirm = await $alert({
                icon: 'info',
                title: t(tokens.inventory.inventory_adjustment),
                text: confirmMsg,
                isConfirm: true,
            })
            if (!isConfirm) return

            setLoading(true)

            const data: any = {
                goodsQty: param.goodsQty,
                invnAdjsTypCd: param.invnAdjsTypCd,
                shlfYmd: param.shlfYmd,
                lotNo: param.lotNo,
                lctSeq: goods.lctSeq,
                goodsId: goods.goodsId,
                invnSeq: goods.invnSeq,
            }
            // console.log('onSubmit', data)
            await $http()
                .put('/inventory/goods-adjustment', data)
                .then((result: any) => {
                    if (!result) return // null pass
                    if (result.succCd !== 'S') {
                        $toast({
                            title: t(tokens.common.fail),
                            icon: 'failure',
                        })
                        return
                    }
                    setLoading(false)
                    $toast({ title: t(tokens.common.success), text: t(tokens.inventory.inventory_adjustment_processed), icon: 'success' })
                    props.onHide(true)
                })
        },
    })

    const onChangeDate = (e: CalendarChangeEvent) => {
        if (e.value instanceof Date) {
            setCalendarDate(e.value)
            formik.setFieldValue('shlfYmd', moment(e.value).format('YYYYMMDD'))
        }
    }

    const header = (title: string) => {
        return <div className="col-12 flex grid py-0">{title}</div>
    }

    const footer = () => {
        return (
            <form className="col-12 flex p-0" onSubmit={formik.handleSubmit}>
                <div className="col-6 flex pl-0">
                    <Button className="w-full p-button-secondary" label={t(tokens.common.close)} size="large" onClick={() => props.onHide(false)} />
                </div>
                <div className="col-6 flex pr-0">
                    <Button className="w-full p-button-warning" label={t(tokens.common.adjustment)} size="large" type="submit" />
                </div>
            </form>
        )
    }

    return (
        <>
            <Dialog
                header={header(t(tokens.inventory.inventory_adjustment))}
                visible={props.visible}
                onHide={() => props.onHide(false)}
                closable={false}
                contentClassName="pb-0"
                footer={footer}
            >
                {loading && <CommonProgressSpinner withBackground={true} />}
                {goods && (
                    <div className="grid">
                        <div className="col-2 flex font-bold mt-2">
                            <label className="text-color-blue text-lg">{t(tokens.common.quantity)}</label>
                        </div>
                        <div className="col-10 flex font-bold mt-2 align-items-center">
                            {goods.avlbGoodsQty} <span className="font-medium pl-2">{goods.gdslsUnitCd}</span>
                        </div>
                        <div className="col-12 flex font-bold mt-2 pt-0">
                            <label className="text-color-blue text-lg required">{t(tokens.inventory.adjustment_type)}</label>
                        </div>
                        <div className="col-12 flex pt-0">
                            <Dropdown
                                id="invnAdjsTypCd"
                                value={formik.values.invnAdjsTypCd}
                                className="w-full p-selectbutton-sm"
                                onChange={onChangeInvnAdjsTypCd}
                                options={invnAdjsTypCd}
                                optionLabel="displayNm"
                                optionValue="codeId"
                                // style={{ minWidth: '180px', zIndex: 2 }}
                            />
                        </div>
                        <div className="col-12 flex pl-2 pt-0">
                            {formik.errors.invnAdjsTypCd ? (
                                <span className="ml-1 mt-1 text-red-600" style={{ fontSize: '12px' }}>
                                    {formik.errors.invnAdjsTypCd}
                                </span>
                            ) : null}
                        </div>
                        <div className="col-12 flex font-bold mt-2 pt-0">
                            <label className="text-color-blue text-lg required">{t(tokens.common.expiration_date)}</label>
                        </div>
                        <div className="col-12 flex pt-0 align-items-center">
                            <Calendar
                                id="shlfYmd"
                                value={calendarDate}
                                onChange={(e) => onChangeDate(e)}
                                selectionMode="single"
                                touchUI
                                dateFormat="y-mm-dd"
                                disabled={disableCalendar}
                                className="ml-0 w-full"
                                showIcon
                                hideOnDateTimeSelect={true}
                            />
                            <Checkbox
                                className="ml-3 mt-1 big-checkbox"
                                inputId="no-exp-adj"
                                style={{ width: '40px', height: '40px' }}
                                checked={formik.values.shlfYmd === '99991231'}
                                disabled={disableCalendar}
                                onChange={(e) => {
                                    if (e.checked) {
                                        setCalendarDate(moment('99991231').toDate())
                                        formik.setFieldValue('shlfYmd', '99991231')
                                    } else {
                                        const today = moment().toDate()
                                        setCalendarDate(today)
                                        formik.setFieldValue('shlfYmd', moment(today).format('YYYYMMDD'))
                                    }
                                }}
                            />
                        </div>
                        <div className="col-12 flex pl-2 pt-0">
                            {formik.errors.shlfYmd ? (
                                <span className="ml-1 mt-1 text-red-600" style={{ fontSize: '12px' }}>
                                    {formik.errors.shlfYmd}
                                </span>
                            ) : null}
                        </div>
                        {formik.values.invnAdjsTypCd === 'LOT' && (
                            <>
                                <div className="col-12 flex font-bold mt-2 pt-0">
                                    <label className="text-color-blue text-lg required">{t(tokens.common.lot_no)}</label>
                                </div>
                                <div className="col-12 flex pt-0">
                                    <InputText
                                        id="lotNo"
                                        placeholder={t(tokens.common.lot_no_input)}
                                        className="w-full"
                                        value={formik.values.lotNo}
                                        onChange={(e: { target: { value: any } }) => formik.setFieldValue('lotNo', e.target.value)}
                                    />
                                </div>
                                <div className="col-12 flex pl-2 pt-0">
                                    {formik.errors.lotNo ? (
                                        <span className="ml-1 mt-1 text-red-600" style={{ fontSize: '12px' }}>
                                    {formik.errors.lotNo}
                                </span>
                                    ) : null}
                                </div>
                            </>
                        )}
                        <div className="col-6 flex font-bold mt-2 pt-0">
                            <label className="text-color-blue text-lg required">{t(tokens.inventory.adjustment_qty)}</label>
                        </div>
                        <div
                            className="col-6 flex text-color-blue mt-2 underline p-align-right text-right pt-0 align-items-center"
                            onClick={onClickAllGoodsQty}
                        >
                            <span className="w-full">
                                {t(tokens.common.total)}
                                {t(tokens.common.quantity)}
                            </span>
                        </div>
                        <div className="col-12 flex pt-0">
                            <InputNumber
                                id="goodsQty"
                                min={goods.gdslsUnitCd === 'KG' ? 0.1 : 1}
                                placeholder={t(tokens.common.please_enter_the_quantity_to_adjust)}
                                inputStyle={{ paddingLeft: '1rem' }}
                                className="w-full"
                                value={formik.values.goodsQty}
                                onChange={(e) => formik.setFieldValue('goodsQty', e.value)}
                                locale="ko-KR"
                                maxFractionDigits={goods.gdslsUnitCd === 'KG' ? 1 : 0}
                                step={goods.gdslsUnitCd === 'KG' ? 0.1 : 1}
                            />
                        </div>
                        <div className="col-12 flex pl-2 pt-0">
                            {formik.errors.goodsQty ? (
                                <span className="ml-1 mt-1 text-red-600" style={{ fontSize: '12px' }}>
                                    {formik.errors.goodsQty}
                                </span>
                            ) : null}
                        </div>
                    </div>
                )}
            </Dialog>
        </>
    )
}

export default InventoryGoodsAdjustmentDialog
